import React, {useEffect, useState} from "react";
import bn from "../../utils/bemnames";
import {BuilderComponentGroupSlug, IBuilderComponentGroup, widgetConfigKeys} from "../../utils/types";
import {_t} from "../../utils/translations";
import {useGlobalState} from "../../contexts/GlobalState";
import {getHashLink, IHashLink, setHashLinkUrl} from "../../utils/url-structure";

interface IProps {
  widgetBuilderGroups: IBuilderComponentGroup[];
  onGroupTabClick: (slug: BuilderComponentGroupSlug) => void;
}

const bem = bn.create('menu');

const Menu: React.FC<IProps> = ({widgetBuilderGroups, onGroupTabClick}) => {
  const getWidgetBuilderGroups = () => widgetBuilderGroups.filter(widgetBuilderGroup => widgetBuilderGroup.slug !== BuilderComponentGroupSlug.header || widgetBuilderGroup.widgetBuilderComponent.length === 0)
  const [currentTabSlug, setCurrentTabSlug] = useState<BuilderComponentGroupSlug|null>((getWidgetBuilderGroups().length > 0 ? getWidgetBuilderGroups()[0].slug : null) ?? null)
  const {globalState} = useGlobalState()
  const [hashLink, setHashLink] = useState<IHashLink|null>(null);

  const onTabClick = () => {
    if (currentTabSlug) {
      onGroupTabClick(currentTabSlug);

      const isHashLinksEnabled = globalState.widget?.configuration?.find((item) => item.key === widgetConfigKeys.enableTabLinks)
      if (isHashLinksEnabled && isHashLinksEnabled.value === '1' && globalState.widget) {
        const isEventIdEnabled = globalState.widget.configuration?.find((item) => item.key === widgetConfigKeys.enableHashEventId)
        let tabObject = globalState.widget.builderComponentGroup.find((item) => item.slug === currentTabSlug)
        if (tabObject) {
          let eventId = isEventIdEnabled && isEventIdEnabled.value === '1' && globalState.event ? globalState.event.id : null
          setHashLinkUrl(tabObject.name, eventId, globalState.widget)
        }
      }
    }
  };

  useEffect(() => {
    if (hashLink !== null && hashLink.path !== null)
      setCurrentTabSlug(BuilderComponentGroupSlug[hashLink.path])
  }, [hashLink])

  useEffect(() => {
    // Handle hash links
    if (globalState.widget) {
      if (globalState.widget.configuration !== null) {
        const isHashLinksEnabled = globalState.widget.configuration.find((item) => item.key === widgetConfigKeys.enableTabLinks)
        if (isHashLinksEnabled !== undefined && isHashLinksEnabled.value === '1') {
          setHashLink(getHashLink(globalState.widget))
        }
      }
    }
  }, [globalState.widget])

  useEffect(onTabClick, [currentTabSlug, globalState.event, globalState.widget?.configuration, onGroupTabClick, globalState.widget])

  return (
    <div className={bem.b()}>
      {widgetBuilderGroups.length > 0 && (
        <>
          <div className={bem.e('main')}>
            {getWidgetBuilderGroups().map(widgetBuilderGroup => {
              return (
                <div
                  className={`${bem.e('main-item')} ${currentTabSlug === widgetBuilderGroup.slug ? bem.e('main-item--active') : ''}`}
                  key={widgetBuilderGroup.id}
                  onClick={() =>{setCurrentTabSlug(widgetBuilderGroup.slug)}}
                >
                  {_t(widgetBuilderGroup.name)}
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default Menu;
